import './style/css/common.css';
import vismusbw from './assets/vismusbw.png';
import TopBar from './components/TopBar';
import { LanguageContextProvider } from './scheleton/context/language-context';
import ApplicationsButtons from './components/ApplicationsButtons';



function PageLayout() {

  function isMobile() {
    const userAgent = typeof window.navigator === "undefined" ? "" : navigator.userAgent;
    return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|Windows Phone/i.test(userAgent);
  }

if (isMobile()){
        return (
          <>
            <LanguageContextProvider>
              <div className="app noScroll">
                  <div className='row fullscreenheight' >
                    <div className='col-12 background-image' >
                          <div className='row' >
                              <div className='col-12'>
                                <TopBar></TopBar>  
                              </div>
                          </div> 
                        <ApplicationsButtons></ApplicationsButtons>

                    </div>
                  </div>
              </div>
            </LanguageContextProvider>
          </>
        )
} 
else
{ 
      return (
        <>
        <LanguageContextProvider>
            <div className="app noScroll">
              <div className='row' >
                <div className='col-12'>
                  <TopBar></TopBar>  
                </div>
              </div>              
                <div className='row' >
                  <div className='col-6' >
                    <ApplicationsButtons></ApplicationsButtons>
                  </div>
                  <div className='col-6'>
                    <img src={vismusbw} alt="VisMus"  />
                  </div>
                    
                </div>
            </div>
        </LanguageContextProvider>
        </>
      )
}
};

const AppMain = () => {
  return (
          <PageLayout>
          </PageLayout>
  );
};
export default AppMain;
